export const getAvailableWidth = (el) => {
  const { paddingLeft, paddingRight, borderLeftWidth, borderRightWidth } = window.getComputedStyle(el);
  const { width } = el.getBoundingClientRect() || {};
  return (
    width -
    (parseFloat(paddingLeft) + parseFloat(paddingRight)) -
    (parseFloat(borderLeftWidth) + parseFloat(borderRightWidth))
  );
};
